export const toastifyClasses = `
.toast_custom {
    width: 371px;
    z-index: 1000000;
}
.toast_custom .Toastify__toast {
    border-radius: 19px;
    padding: 8px 8px 7px 58px;
}
.toast_custom .Toastify__progress-bar {
    height: 7px;
    opacity: 0.54 !important;
}
.Toastify__toast--info {
    background: #0093ee;
}
.Toastify__toast--success {
    background: #25bec8; 
}
.Toastify__toast--error {
    background: #1f2741;
}
.toast_custom .Toastify__toast-body::before {
    font-family: 'Montserrat-extrabold', 'Montserrat-bold', Arial, sans-serif;
    font-size: 18px;
    line-height: 1.38;
    letter-spacing: -0.1px;
    display: block;
}
.toast_custom .Toastify__toast--error .Toastify__toast-body::before {
    content: 'Error:';
    color: #1f2741;
}
.toast_custom .Toastify__toast--info .Toastify__toast-body::before {
    content: '';
    color: #0093ee;
}
.toast_custom .Toastify__toast--success .Toastify__toast-body::before {
    content: 'Confirmation:';
    color: #25bec8;
}
.toast_custom .Toastify__close-button {
    position: absolute;
    right: 15px;
    top: 15px;
    opacity: 1;
}
.toast_custom .Toastify__close-button::before {
    content: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4yLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i0KHQu9C+0LlfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCAxOCAxNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTggMTQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiMxRjI3NDE7c3Ryb2tlOiMxRjI3NDE7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMywxMi42bC00LTRsLTQsNGMtMC40LDAuNC0xLjIsMC40LTEuNiwwbDAsMGMtMC40LTAuNC0wLjQtMS4yLDAtMS42bDAsMGw0LTRsLTQtNGMtMC40LTAuNC0wLjQtMS4yLDAtMS42DQoJbDAsMGMwLjQtMC40LDEuMi0wLjQsMS42LDBsMCwwbDQsNGw0LTRjMC40LTAuNCwxLjItMC40LDEuNiwwbDAsMGMwLjQsMC40LDAuNCwxLjIsMCwxLjZsMCwwbC00LDRsNCw0YzAuNCwwLjQsMC40LDEuMiwwLDEuNmwwLDANCglDMTQuMiwxMywxMy41LDEzLDEzLDEyLjZMMTMsMTIuNkwxMywxMi42eiIvPg0KPC9zdmc+DQo=")
}
.toast_custom .Toastify__close-button svg {
    display: none;
}
.toast_custom .Toastify__toast-body {
    font-family: 'HelveticaNeue-medium', Arial, sans-serif;
    line-height: 1.38;
    letter-spacing: -0.09px;
    color: #1f2741;
    background: #ffffff;
    border-radius: 0 14px 14px 0;
    opacity: 0.96;
    padding: 9px 29px 21px 14px;
    margin-left: 6px;
    width: 100%;
    white-space: pre-wrap;
    word-break: break-word;
}
.toast_custom .Toastify__toast--success .Toastify__toast-body {
    font-size: 16px;
}
.toast_custom .Toastify__toast--info .Toastify__toast-body {
    font-size: 16px;
}
.toast_custom .Toastify__toast--error .Toastify__toast-body {
    font-size: 18px;
}
.toast_custom .Toastify__toast::before {
    background: #FFFFFF;  
    border-radius: 50%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 15px;
    top: calc(50% - 17px);
    width: 26px;
    height: 30px;
    padding: 4px 4px 0 4px;
}
.toast_custom .Toastify__toast--info::before {
    content : url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4yLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i0KHQu9C+0LlfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxOC42cHgiIGhlaWdodD0iMTQuN3B4IiB2aWV3Qm94PSIwIDAgMTguNiAxNC43IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxOC42IDE0Ljc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiMwMDkzRUU7fQ0KPC9zdHlsZT4NCjxnPg0KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03LDE0LjNjLTAuNCwwLTAuOS0wLjItMS4yLTAuNWwtNS01Yy0wLjYtMC42LTAuNi0xLjcsMC0yLjNzMS43LTAuNiwyLjMsMGwwLDBMNywxMC4zbDguNS05LjUNCgkJYzAuNi0wLjYsMS43LTAuNiwyLjMsMGwwLDBjMC42LDAuNiwwLjYsMS43LDAsMi4zTDguMiwxMy44QzcuOCwxNC4yLDcuNCwxNC4zLDcsMTQuM3oiLz4NCjwvZz4NCjwvc3ZnPg0K");
}
.toast_custom .Toastify__toast--success::before {
    content : url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4yLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i0KHQu9C+0LlfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxOC42cHgiIGhlaWdodD0iMTQuN3B4IiB2aWV3Qm94PSIwIDAgMTguNiAxNC43IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxOC42IDE0Ljc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiMyNUJFQzg7fQ0KPC9zdHlsZT4NCjxpbWFnZSBzdHlsZT0iZGlzcGxheTpub25lO292ZXJmbG93OnZpc2libGU7IiB3aWR0aD0iNDMiIGhlaWdodD0iNDciIHhsaW5rOmhyZWY9IkU2NkMyM0ExLmpwZyIgIHRyYW5zZm9ybT0ibWF0cml4KDAuNDQ3NyAwIDAgMC40NDc3IDQuNDc5NSAxLjA2MjUpIj4NCjwvaW1hZ2U+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNywxNC4zYy0wLjQsMC0wLjktMC4yLTEuMi0wLjVsLTUtNWMtMC42LTAuNi0wLjYtMS43LDAtMi4zYzAuNi0wLjYsMS43LTAuNiwyLjMsMGMwLDAsMCwwLDAsMEw3LDEwLjMNCgkJbDguNS05LjVjMC42LTAuNiwxLjctMC42LDIuMywwYzAsMCwwLDAsMCwwYzAuNiwwLjYsMC42LDEuNywwLDIuM0w4LjIsMTMuOEM3LjgsMTQuMiw3LjQsMTQuMyw3LDE0LjN6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==");
}
.toast_custom .Toastify__toast--error::before {
    content : url("data:image/svg+xml;base64,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");
}
`;
